var _rect, _mask, _rect2, _mask2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBallotBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 121,
    viewBox: "0 0 239 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94.134,
    y: 20.0344,
    width: 42.1915,
    height: 44,
    transform: "rotate(-28.1383 94.134 20.0344)",
    fill: "#F0F0F0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_123_170",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.134,
    y: 30,
    width: 159,
    height: 20,
    rx: 3
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.134,
    y: 30,
    width: 159,
    height: 20,
    rx: 3,
    fill: "#DBC8C0",
    stroke: "black",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    mask: "url(#path-2-inside-1_123_170)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_123_170",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.134,
    y: 45,
    width: 128,
    height: 75,
    rx: 3
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57.134,
    y: 45,
    width: 128,
    height: 75,
    rx: 3,
    fill: "#DBC8C0",
    stroke: "black",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    mask: "url(#path-3-inside-2_123_170)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57.134,
    y: 50,
    width: 128,
    height: 7,
    fill: "#7B706C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 83.134,
    y: 70,
    width: 71,
    height: 31,
    rx: 8,
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.4 90.9688C140.901 91.6062 140.271 92.0981 139.509 92.4445C138.747 92.7909 137.957 92.9641 137.14 92.9641C136.364 92.9641 135.629 92.8394 134.937 92.5899C134.258 92.3405 133.662 91.9872 133.149 91.53C132.65 91.0589 132.255 90.4978 131.965 89.8465C131.674 89.1953 131.528 88.4679 131.528 87.6643C131.528 86.8607 131.674 86.1332 131.965 85.482C132.255 84.8308 132.65 84.2766 133.149 83.8193C133.662 83.3483 134.258 82.988 134.937 82.7386C135.629 82.4892 136.364 82.3645 137.14 82.3645C137.86 82.3645 138.511 82.4892 139.093 82.7386C139.689 82.988 140.188 83.3483 140.59 83.8193C141.005 84.2766 141.324 84.8308 141.546 85.482C141.767 86.1332 141.878 86.8607 141.878 87.6643V88.6411H134.646C134.77 89.2369 135.04 89.7149 135.456 90.0752C135.872 90.4215 136.384 90.5947 136.994 90.5947C137.507 90.5947 137.936 90.4839 138.283 90.2622C138.643 90.0267 138.955 89.7288 139.218 89.3685L141.4 90.9688ZM138.761 86.5212C138.775 85.9947 138.601 85.5444 138.241 85.1703C137.881 84.7962 137.417 84.6091 136.849 84.6091C136.502 84.6091 136.197 84.6645 135.934 84.7754C135.671 84.8862 135.442 85.0317 135.248 85.2118C135.068 85.3781 134.923 85.579 134.812 85.8146C134.715 86.0362 134.659 86.2718 134.646 86.5212H138.761Z",
    fill: "#6C2023"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.256 85.1079H127.512V88.4748C127.512 88.7519 127.526 89.0083 127.554 89.2438C127.581 89.4655 127.644 89.6595 127.741 89.8258C127.838 89.992 127.983 90.1237 128.177 90.2206C128.385 90.3038 128.655 90.3453 128.988 90.3453C129.154 90.3453 129.369 90.3315 129.632 90.3038C129.909 90.2622 130.117 90.1791 130.256 90.0544V92.6523C129.909 92.777 129.549 92.8601 129.175 92.9017C128.801 92.9433 128.434 92.9641 128.073 92.9641C127.547 92.9641 127.062 92.9086 126.618 92.7978C126.175 92.6869 125.787 92.5137 125.455 92.2782C125.122 92.0288 124.859 91.7101 124.665 91.3222C124.485 90.9342 124.395 90.4631 124.395 89.9089V85.1079H122.399V82.6139H124.395V79.6211H127.512V82.6139H130.256V85.1079Z",
    fill: "#6C2023"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.317 87.6643C110.317 86.8607 110.462 86.1332 110.753 85.482C111.044 84.8308 111.439 84.2766 111.938 83.8193C112.451 83.3483 113.046 82.988 113.725 82.7386C114.418 82.4892 115.153 82.3645 115.928 82.3645C116.704 82.3645 117.432 82.4892 118.111 82.7386C118.803 82.988 119.399 83.3483 119.898 83.8193C120.411 84.2766 120.813 84.8308 121.103 85.482C121.394 86.1332 121.54 86.8607 121.54 87.6643C121.54 88.4679 121.394 89.1953 121.103 89.8465C120.813 90.4978 120.411 91.0589 119.898 91.53C119.399 91.9872 118.803 92.3405 118.111 92.5899C117.432 92.8394 116.704 92.9641 115.928 92.9641C115.153 92.9641 114.418 92.8394 113.725 92.5899C113.046 92.3405 112.451 91.9872 111.938 91.53C111.439 91.0589 111.044 90.4978 110.753 89.8465C110.462 89.1953 110.317 88.4679 110.317 87.6643ZM113.434 87.6643C113.434 88.4263 113.649 89.0429 114.079 89.514C114.522 89.9851 115.139 90.2206 115.928 90.2206C116.718 90.2206 117.328 89.9851 117.757 89.514C118.201 89.0429 118.422 88.4263 118.422 87.6643C118.422 86.9022 118.201 86.2856 117.757 85.8146C117.328 85.3435 116.718 85.1079 115.928 85.1079C115.139 85.1079 114.522 85.3435 114.079 85.8146C113.649 86.2856 113.434 86.9022 113.434 87.6643Z",
    fill: "#6C2023"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.134 78H99.8335L103.471 87.6435H103.512L107.212 78H110.682L104.614 92.7147H102.016L96.134 78Z",
    fill: "#6C2023"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallotBox);
export default __webpack_public_path__ + "static/media/ballotBox.937ba4aec71520311487a453caa9be10.svg";
export { ForwardRef as ReactComponent };